export default {
    title: '<strong>Teacher</strong> and <strong>Student</strong> participate together in <strong>real-time Session Activities</strong>',
    buttons: {
        teacher: 'Start Session as Teacher',
        student: 'Enter as Student',
    },
};
